// Classe Utilitários - Este objecto foi criado para agrupar funções compartilhadas
// Autor  -Softline - Angola
const swal  = require('sweetalert2')
const crypto = require('crypto')
const numero = require('numero-por-extenso')
const ls = require('local-storage')
const utilitarios = {

  arrayMultas: [],


  ObterValorPorExtensao(result){
    let valor = numero.porExtenso((result)?result:0)
        valor =  (valor.includes('um mil')) ? valor.replace('um mil', 'mil') : valor

        return valor+' Kwanzas'
  },

  ArrayCLasses(){
     return  [
            {id:1,descricao:'10ª Classe'},
            {id:2,descricao:'11ª Classe'},
            {id:3,descricao:'12ª Classe'},
            {id:4,descricao:'13ª Classe'}
     ]
  },


  returnDataCorrectFormat(data){
    return data.split('-')[2]+'-'+data.split('-')[1]+'-'+data.split('-')[0]
  },

 capitalize(word) {
    const lower = word.toLowerCase();
    return word.charAt(0).toUpperCase() + lower.slice(1);
  },

  SetNameCapitalize (fullName) {  

    const words = fullName.toLowerCase().split(" ")
    
    for (let i = 0; i < words.length; i++) {
        words[i] = words[i][0].toUpperCase() + words[i].substr(1);
    }
    
    return  words.join(" ");
 },

 reverseGroupConcat(arrayMysql){

    let arr = arrayMysql.split(',')
    let arrnovo = []
    if(arr.length){
       for (let index = arr.length-1; index >= 0; index--) {
         arrnovo.push(arr[index])
        
       }

       return arrnovo
    }
    return []

 },

   MonthsOfYear(){
    let meses =  [
       { id: '1', descricao: 'Janeiro' },
       { id: '2', descricao: 'Fevereiro' },
       { id: '3', descricao: 'Março' },
       { id: '4', descricao: 'Abril' },
       { id: '5', descricao: 'Maio' },
       { id: '6', descricao: 'Junho' },
       { id: '7', descricao: 'Julho' },
       { id: '8', descricao: 'Agosto' },
       { id: '9', descricao: 'Setembro' },
       { id: '10', descricao: 'Outubro' },
       { id: '11', descricao: 'Novembro' },
       { id: '12', descricao: 'Dezembro' }
     ]

     return meses
   },

  MoneyValueToInteger (valor) {
    let v = valor.toString().split('.')
    let join = v.join('')
    let v2 = join.replace(' Kz', '')
    let v3 = v2.replace(',', '.')

    return parseFloat(v3)
  },

  

  MoneyValueToIntegerWithouKz (valor) {
    let v = valor.toString().split('.')
    let join = v.join('')
    let v3 = join.replace(',', '.')

    return parseFloat(v3)
  },
  
  IntegerToMoneyValue (valor) {
    let formated = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'AOA' }).format(valor)
    return formated.toString().replace('AOA', '') + ' Kz'
  },
  IntegerToMoneyValueFatura (valor) {
    let formated = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'AOA' }).format(valor)
    return formated.toString().replace('AOA', '')
  },

  ObterAnoByDate (date) {
    var today = new Date(date)
    var date = today.getFullYear() 
    return date
  },

  ObterMonthByDate (date) {
    var today = new Date(date)
    let month = (1 + today.getMonth()).toString().padStart(2, '0');
    return parseInt(month)
  },

  ObterDayhByDate (date) {
    var today = new Date(date)
    let day = today.getDate()
    return parseInt(day)
  },

  ObterValorDaPercentagem (valor, percentagem) {
    return valor * percentagem / 100
  },
  ObterValorDaPercentagemBolseiro (valor, percentagem, objectBolsa) {
    if(objectBolsa.ongBolsa === 'IGNABE')
      return 0
      return valor * percentagem / 100
  },

  ObterIVA (valorTotal) {
    return (valorTotal * 14) / 100
  },

  CalculaEAdicionaIva (valorTotal, percentagem) {
    let iva = valorTotal * percentagem / 100
    return valorTotal + iva
  },

  getHashValuesIndexs(hash){
    return hash[0]+hash[10]+hash[20]+hash[30]
  },


  CriarHASHFactura(SystemEntryData,InvoiceDateHash, InvoiceNo,GrossTotal){
    var sha = crypto.createHash('sha1');
    sha.update(String(InvoiceDateHash+';'+SystemEntryData+';'+InvoiceNo+';'+GrossTotal.toFixed(2)))
    var hash = sha.digest('hex');
    return hash[0]+hash[10]+hash[20]+hash[30]
  },


  getMonthDescriptionPropina(pkmes){
    switch (pkmes) {
        case 1:
         return '( Janeiro ) '+ls.get('descricaoAnolectivo')
        case 2:
         return '( Fevereiro ) '+ls.get('descricaoAnolectivo')
         case 3:
        return '( Março ) '+ls.get('descricaoAnolectivo')
        case 4:
        return '( Abril ) '+ls.get('descricaoAnolectivo')
        case 5:
        return '( Maio ) '+ls.get('descricaoAnolectivo')
        case 6:
        return '( Junho ) '+ls.get('descricaoAnolectivo')
        case 7:
        return '( Julho ) '+ls.get('descricaoAnolectivo')
        case 8:
         return '( Agosto ) '+ls.get('descricaoAnolectivo')
         case 9:
        return '( Setembro ) '+ls.get('descricaoAnolectivo')
        case 10:
        return '( Outubro ) '+ls.get('descricaoAnolectivo')
        case 11:
        return '( Novembro ) '+ls.get('descricaoAnolectivo')
        case 12:
        return '( Dezembro ) '+ls.get('descricaoAnolectivo')

      default:
        return '';
    }
 },

  getMonthDescription(pkmes){
     switch (pkmes) {
         case 1:
          return 'Janeiro'
         case 2:
          return 'Fevereiro'
          case 3:
         return 'Março'
         case 4:
         return 'Abril'
         case 5:
         return 'Maio'
         case 6:
         return 'Junho'
         case 7:
         return 'Julho'
         case 8:
          return 'Agosto'
          case 9:
         return 'Setembro'
         case 10:
         return 'Outubro'
         case 11:
         return 'Novembro'
         case 12:
         return 'Dezembro'

       default:
         return 'N/A';
     }
  },

  correntDate () {
    let data = new Date()
    var month = []
    month[0] = 'Janeiro'
    month[1] = 'Fevereiro'
    month[2] = 'Maço'
    month[3] = 'Abril'
    month[4] = 'Maio'
    month[5] = 'Junho'
    month[6] = 'Julho'
    month[7] = 'Agosto'
    month[8] = 'Setembro'
    month[9] = 'Outubro'
    month[10] = 'Novembro'
    month[11] = 'Dezembro'
    return data.getDate().toString() + ' de ' + month[(data.getMonth())] + ' de ' + data.getFullYear().toString() + ' ás ' + data.getHours() + ':' + data.getMinutes() + ':' + data.getSeconds()
  },


  getLastDayOfMonth(ano,mes){
    var lastDayOfMonth = new Date(ano,mes, 0);

    return lastDayOfMonth
  },

 

  AdicionarDiasaDataActual(days){
    var date = new Date();
    date.setDate(date.getDate() + days);
    return this.ObterData(date);
  },

  

  difDateMultaAndDateNow(dateMulta,dateNow){


    var dt1 = new Date(`${dateMulta} 11:23:00`);
    var dateMultaAux = new Date(`${dateMulta} 11:23:00`);
    var dt2= new Date(`${dateNow} 11:23:00`); 
    let dif = Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate()) ) /(1000 * 60 * 60 * 24));
    let arrDate =[]
    for (let index = 0; index <=dif ; index+=1){
      dateMultaAux.setDate(dt1.getDate() + index);
      if( (dateMultaAux.getDay()===0 || dateMultaAux.getDay()==6))
      arrDate.push({"daysOfWeek": dateMultaAux.getDay()})
    }
   //return {difDays:dif,"daysOfWeek":arrDate.length}
   return dif-arrDate.length
  },
  holidays(dateMulta,arrayferiados){

    var dateMultaAux = new Date(`${dateMulta} 11:23:00`);      
    let holidays = 0
    arrayferiados.forEach(element => {
      let day= new Date(`${element.day} 11:23:00`);
      
      /**Quando o feriado for terça-feira ou quinta-feira deve somar dois dias (o feriado + a data anterior) */
      if( (day>dateMultaAux) && (day.getDay()===2 || day.getDay()==4)){ holidays+=2 }
      else 
       /**Quando o feriado for segunda-feira,quarta-feira e sexta-feira */
      if( (day>dateMultaAux) && (day.getDay() > 0 && day.getDay() < 6)){ holidays++ }
      
    });      
  return holidays
  },

  AdicionarDiasaUmaData(newDate){
    var date2 = new Date(`${newDate} 11:23:00`); 
    /**Domingo */    
  if(date2.getDay()===0){    
date2.setDate(date2.getDate() + 1);
return {data: (date2.getFullYear() + '-' + (date2.getMonth() + 1) + '-' + date2.getDate()),day:date2.getDay()};
  }else{
    /**Sábado */ 
    if(date2.getDay()===6){
date2.setDate(date2.getDate() + 2);
return {data:(date2.getFullYear() + '-' + (date2.getMonth() + 1) + '-' + date2.getDate()),day:date2.getDay()};
    }
  }
  /**outros dias */ 
  return {data:(date2.getFullYear() + '-' + (date2.getMonth() + 1) + '-' + date2.getDate()),day:date2.getDay()};

  },

  ObterNumeroDeDias(date1, date2){
    var data1 = new Date(date1);
    var data2 = new Date(date2);
    var Difference_In_Time = data2.getTime() - data1.getTime();
    // To calculate the no. of days between two dates
    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
    return Difference_In_Days

  },


  ObterHoraActual () {
    var today = new Date()
    var time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds()
    return time
  },

    //
  ObterDigitosHashParaFactura(hash) {

    if (hash) {
      return hash[0]+hash[10]+hash[20]+hash[30]
    } else {
      return '';
    }
  },
  ObterDataActural () {
    var date = new Date()
    let year = date.getFullYear();
    let month = (1 + date.getMonth()).toString().padStart(2, '0');
    let day = date.getDate().toString().padStart(2, '0');
    var date_ = year + '-'  + month + '-' + day
    return date_
  },

  ObterMesActual () {
    var date = new Date()
    let month = (1 + date.getMonth()).toString().padStart(2, '0');
    return month
  },


  ObterMesByData (dataparams) {
    var date = new Date(dataparams)
    let month = (1 + date.getMonth()).toString().padStart(2, '0');
    return month
  },

  ObterAnoByData (dataparams) {
    var today = new Date(dataparams)
    var date = today.getFullYear()
    return date
  },


  ObterDATAHashFormat () {

    return this.ObterDataActural()+'T'+this.ObterHoraActual()

  },


  ObterANOActual () {
    var today = new Date()
    var date = today.getFullYear()
    return date
  },

  ObterData (data) {
    var date = data.getFullYear() + '-' + (data.getMonth() + 1) + '-' + data.getDate()
    return date
  },

  removeArrayFromOhter (array1, array2) {
    var c = array1
    c = array1.filter(x => !array2.filter(y => y.fkMes === x.fkMes).length) // array1.filter(x => !array2.includes(x.fkMes))
    return c
  },

  ObterReciboComMarioValor (arr) {
    let max = 0
    let min = 0
    let res = null
    for (let i = 1; i < arr.length; i++) {
      let value = arr[i].valor
      min = (value < min) ? value : min
      if (value > max) {
        max = value
        res = arr[i]
      } else { max = max }
    }

    return res
  },
  /**
   * 
   * @param {*} type 
   * @param {*} message 
   * Type , success, warning, error, info
   * Message ,  Text to be print
   */
  showAlertMessage (type,message){
    swal.fire({icon: type,title: message})
  },

  AdicionarMultaAOArray (dataRecibo, arrayPagamentos, precoPropina) {
    let datarecibo = new Date(dataRecibo)
    // Prints "name Jean-Luc Picard" followed by "rank Captain"
    Object.keys(arrayPagamentos).forEach(i => { // Obtem as datas da muulta
      let data1 = new Date(arrayPagamentos[i].data1)
      let data2 = new Date(arrayPagamentos[i].data2)
      let data3 = new Date(arrayPagamentos[i].data3)
      let data4 = new Date(arrayPagamentos[i].data4)
      let data5 = new Date(arrayPagamentos[i].data5)

      if( datarecibo  > data1 ){ // caso a data de pagamento seja maior que a data 5
          arrayPagamentos[i].multa = precoPropina[0].valor1
          arrayPagamentos[i].tipoMulta = precoPropina[0].tipoMulta
          this.arrayMultas[i] = arrayPagamentos[i]
      } 
      //   else if( datarecibo  > data1 ) {
      //     arrayPagamentos[i].multa = precoPropina[0].valor1
      //     arrayPagamentos[i].tipoMulta = precoPropina[0].tipoMulta
      //     this.arrayMultas[i] = arrayPagamentos[i]
      // }
      //   else if( datarecibo  > data1 ) {
      //     arrayPagamentos[i].multa = precoPropina[0].valor1
      //     arrayPagamentos[i].tipoMulta = precoPropina[0].tipoMulta
      //     this.arrayMultas[i] = arrayPagamentos[i]
      // }
      //   else if( datarecibo  > data1 ) {
      //     arrayPagamentos[i].multa = precoPropina[0].valor1
      //     arrayPagamentos[i].tipoMulta = precoPropina[0].tipoMulta
      //     this.arrayMultas[i] = arrayPagamentos[i]
      // }
      //   else if( datarecibo  > data1 ) {
      //     arrayPagamentos[i].multa = precoPropina[0].valor1
      //     arrayPagamentos[i].tipoMulta = precoPropina[0].tipoMulta
      //     this.arrayMultas[i] = arrayPagamentos[i]
      else{
          arrayPagamentos[i].multa  = 0
          arrayPagamentos[i].tipoMulta = precoPropina[0].tipoMulta
      }

      // if (data3 < datarecibo) {
      //   arrayPagamentos[i].multa = precoPropina[0].valor3
      //   arrayPagamentos[i].tipoMulta = precoPropina[0].tipoMulta
      //   this.arrayMultas[i] = arrayPagamentos[i]
      // } else if (data2 < datarecibo) {
      //   arrayPagamentos[i].multa = precoPropina[0].valor2
      //   arrayPagamentos[i].tipoMulta = precoPropina[0].tipoMulta
      //   this.arrayMultas[i] = arrayPagamentos[i]
      // } else if (data1 < datarecibo) {
      //   arrayPagamentos[i].multa = precoPropina[0].valor1
      //   arrayPagamentos[i].tipoMulta = precoPropina[0].tipoMulta
      //   this.arrayMultas[i] = arrayPagamentos[i]
      // }else{
      //   arrayPagamentos[i].multa  = 0
      //   arrayPagamentos[i].tipoMulta = precoPropina[0].tipoMulta
      // }
    })
    return arrayPagamentos
  },

  // AdicionarMultaAOArrayOriginal (dataRecibo, arrayPagamentos, precoPropina) {
  //   let datarecibo = new Date(dataRecibo)
  //   // Prints "name Jean-Luc Picard" followed by "rank Captain"
  //   Object.keys(arrayPagamentos).forEach(i => {
  //     let data1 = new Date(arrayPagamentos[i].data1)
  //     let data2 = new Date(arrayPagamentos[i].data2)
  //     let data3 = new Date(arrayPagamentos[i].data3)

  //     if (data3 < datarecibo) {
  //       arrayPagamentos[i].multa = precoPropina[0].valor3
  //       arrayPagamentos[i].tipoMulta = precoPropina[0].tipoMulta
  //       this.arrayMultas[i] = arrayPagamentos[i]
  //     } else if (data2 < datarecibo) {
  //       arrayPagamentos[i].multa = precoPropina[0].valor2
  //       arrayPagamentos[i].tipoMulta = precoPropina[0].tipoMulta
  //       this.arrayMultas[i] = arrayPagamentos[i]
  //     } else if (data1 < datarecibo) {
  //       arrayPagamentos[i].multa = precoPropina[0].valor1
  //       arrayPagamentos[i].tipoMulta = precoPropina[0].tipoMulta
  //       this.arrayMultas[i] = arrayPagamentos[i]
  //     }else{
  //       arrayPagamentos[i].multa  = 0
  //       arrayPagamentos[i].tipoMulta = precoPropina[0].tipoMulta
  //     }
  //   })
  //   return arrayPagamentos
  // },

  RetornaArrayMulta (mes, precoPropina,Mesesprazos) {
     let datarecibo = new Date()
     let mesPrazo = Mesesprazos.filter( m=>m.fkMes === mes )
     if(mesPrazo.length){
          let data1 = new Date(mesPrazo[0].data1)
          let data2 = new Date(mesPrazo[0].data1)
          let data3 = new Date(mesPrazo[0].data1)
          if (data1 < datarecibo) {
           return precoPropina[0].valor1
          } else if (data1 < datarecibo) {
          return precoPropina[0].valor1
          } else if (data1 < datarecibo) {
            return precoPropina[0].valor1
          }else{
           return 0
          }
     }else{
      return 0
     }
  },

  

  AdicionarMultaAOObjecto (objPagamento, precoPropina, dataPagamento) {
    let datarecibo = new Date(dataPagamento)
    // Prints "name Jean-Luc Picard" followed by "rank Captain"
    let data1 = new Date(objPagamento.data1)
    let data2 = new Date(objPagamento.data2)
    let data3 = new Date(objPagamento.data3)

    if (data3 < datarecibo) {
      objPagamento.multa = precoPropina[0].valor3
      objPagamento.tipoMulta = precoPropina[0].tipoMulta
    } else if (data2 < datarecibo) {
      objPagamento.multa = precoPropina[0].valor2
      objPagamento.tipoMulta = precoPropina[0].tipoMulta
    } else if (data1 < datarecibo) {
      objPagamento.multa = precoPropina[0].valor1
      objPagamento.tipoMulta = precoPropina[0].tipoMulta
    }
    return objPagamento
  },

  AdicionarMultaAOArrayCurrentDate (arrayPagamentos, precoPropina) {
    let datarecibo = new Date()
    // Prints "name Jean-Luc Picard" followed by "rank Captain"
    Object.keys(arrayPagamentos).forEach(i => {
      let data1 = new Date(arrayPagamentos[i].data1)
      let data2 = new Date(arrayPagamentos[i].data2)
      let data3 = new Date(arrayPagamentos[i].data3)

      if (data3 < datarecibo) {
        arrayPagamentos[i].multa = precoPropina[0].valor3
        arrayPagamentos[i].tipoMulta = precoPropina[0].tipoMulta
        this.arrayMultas[i] = arrayPagamentos[i]
      } else if (data2 < datarecibo) {
        arrayPagamentos[i].multa = precoPropina[0].valor2
        arrayPagamentos[i].tipoMulta = precoPropina[0].tipoMulta
        this.arrayMultas[i] = arrayPagamentos[i]
      } else if (data1 < datarecibo) {
        arrayPagamentos[i].multa = precoPropina[0].valor1
        arrayPagamentos[i].tipoMulta = precoPropina[0].tipoMulta
        this.arrayMultas[i] = arrayPagamentos[i]
      }
    })
    return arrayPagamentos
  },



  /******
   * 
   * 
   *  FUNÇÕES CRIADAS PARA A REDUÇÃO AUTOMÁTICA DA IMAGEM
   * 
   */



  








}
module.exports = utilitarios
